export enum RoutePaths {
    LOGIN = '/login',
    PROFILE = '/profile',
    HOME = '/home',
    TRAININGS = '/trainings',
    USERS_MANAGEMENT = '/users-management',
    STATISTICS = '/statistics',
    EDITOR = '/editor',
    LIVE = '/live',
    FORGOT_PASSWORD = '/forgot-password',
    FINISH_REGISTRATION = '/finish-registration',
    CONTENT_OF_REGULATIONS = '/content-of-regulations',
    PRIVACY_POLICY = '/privacy-policy',
    RESET_PASSWORD = '/reset-password',
    CONFIRM_EMAIL = '/confirm-email',
    UNAUTHORIZED = '/unauthorized',
    INVITATION_ERROR = '/invitation-error',
    RESET_PASSWORD_ERROR = '/reset-password-error',
    MFA = '/mfa',
    WORKSPACE_SETTINGS = '/workspace-settings',
}
